import { useCallback } from 'react';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
/** A hook that resolves the auth data from the app token params. */
export const useAuthSearchParams = () => {
    const { params: { refreshToken }, unsetParam, } = useAppSearchParams('/');
    /**
     * Gets the auth data through the login api endpoint for exchanging the login
     * token and organization id to the auth data.
     */
    const getAuthDataFromSearchParam = useCallback(() => {
        if (!refreshToken) {
            return Promise.reject();
        }
        unsetParam('refreshToken');
        return Promise.resolve({
            type: 'searchParams',
            asyncStatus: 'fulfilled',
            authData: { refresh_token: refreshToken },
        });
    }, [refreshToken, unsetParam]);
    /** Triggers the retrieval of the auth data in a promise. */
    const trigger = useCallback(() => {
        return getAuthDataFromSearchParam();
    }, [getAuthDataFromSearchParam]);
    return trigger;
};
